module.exports = __webpack_public_path__ + "static/media/MG.ab73662e.svg";